// extracted by mini-css-extract-plugin
export default {"addToCartControl":"RZ-z","giftCard":"SZ-z","btnContainer":"TZ-z","cartButton":"UZ-z","disabled":"VZ-z"};